export interface PreloadedNumerologyReading {
    number: number;
    description: string;
    qualities: string[];
    challenges: string[];
    love: string;
    work: string;
    advice: string;
}

export const NUMEROLOGY_PRELOADED_READINGS: Record<number, PreloadedNumerologyReading> = {
    1: {
        number: 1,
        description: "L'Initiateur et le Pionnier. Votre âme est incarnée pour ouvrir de nouvelles voies, diriger avec assurance et affirmer une individualité créatrice forte.",
        qualities: ["Leadership naturel", "Esprit d'initiative", "Indépendance", "Volonté inébranlable"],
        challenges: ["Tendance à l'autoritarisme", "Impatience face aux lenteurs", "Peur de dépendre d'autrui"],
        love: "En amour, vous recherchez un partenaire qui respecte votre liberté et admire votre détermination, sans jamais chercher à brider vos ambitions.",
        work: "Porté vers les rôles de direction, l'entrepreneuriat ou les professions indépendantes. Vous excellez lorsque vous êtes maître de votre destin.",
        advice: "Osez prendre les devants sans crainte, mais veillez à intégrer l'écoute et la douceur dans vos relations."
    },
    2: {
        number: 2,
        description: "Le Médiateur et le Diplomate. Votre voie réside dans l'harmonie, la coopération subtile et la création de liens affectifs sincères et durables.",
        qualities: ["Intuition affûtée", "Grande empathie", "Sens de la conciliation", "Délicatesse relationnelle"],
        challenges: ["Hypersensibilité aux conflits", "Doute de soi", "Tendance à s'oublier pour les autres"],
        love: "Votre cœur aspire à une union romantique et fusionnelle où règnent la sécurité émotionnelle, la tendresse réciproque et le respect attentif.",
        work: "Particulièrement doué dans les métiers d'équipe, le conseil, la médiation ou le soin. Vous êtes le liant indispensable à la réussite collective.",
        advice: "N'ayez pas peur d'exprimer vos propres besoins avec fermeté tout en préservant votre belle sensibilité."
    },
    3: {
        number: 3,
        description: "Le Créateur et l'Inspirateur. Votre mission est d'apporter la joie, la lumière et l'enthousiasme à travers l'expression de votre talent créatif.",
        qualities: ["Charisme pétillant", "Aisance relationnelle", "Créativité débordante", "Optimisme contagieux"],
        challenges: ["Dispersion de l'énergie", "Superficialité passagère", "Crainte de la routine"],
        love: "La séduction et la légèreté stimulent votre esprit. Vous vous épanouissez aux côtés d'une personne qui partage votre gaieté et votre goût de vivre.",
        work: "Succès promis dans la communication, l'artistique, le journalisme, l'événementiel ou le commerce. Votre parole est une arme d'attraction.",
        advice: "Canalisez votre imagination féconde vers un objectif précis pour transformer vos étincelles en succès durable."
    },
    4: {
        number: 4,
        description: "Le Bâtisseur et le Protecteur. Votre incarnation repose sur la construction de fondations concrètes, la rigueur, l'honnêteté et la pérennité.",
        qualities: ["Rigueur exemplaire", "Sens de l'organisation", "Loyauté indéfectible", "Endurance à toute épreuve"],
        challenges: ["Rigidité d'esprit", "Résistance au changement", "Anxiété matérielle"],
        love: "Très fidèle et protecteur, vous prouvez votre attachement par des actes concrets et la création d'un foyer stable plutôt que par de longs discours.",
        work: "Incontournable dans l'ingénierie, l'administration, la gestion, l'architecture ou le droit. Vous transformez le désordre en structure solide.",
        advice: "Accueillez l'imprévu avec souplesse et autorisez-vous des pauses de sérénité sans culpabilité."
    },
    5: {
        number: 5,
        description: "L'Aventurier et le Libérateur. Votre chemin est guidé par la quête de liberté, le changement stimulant et l'exploration audacieuse du monde.",
        qualities: ["Grande adaptabilité", "Inspiration novatrice", "Esprit d'aventure", "Polyvalence brillante"],
        challenges: ["Instabilité décisionnelle", "Recherche d'excès", "Peur de l'engagement"],
        love: "Une passion palpitante qui refuse l'étouffement. Il vous faut un partenaire autonome qui transforme la vie de couple en un voyage permanent.",
        work: "Épanouissement garanti dans le voyage, le marketing, l'innovation, les médias ou les activités indépendantes à fort renouvellement.",
        advice: "Transformez votre soif de liberté en une force d'évolution constante sans négliger vos ancrages essentiels."
    },
    6: {
        number: 6,
        description: "Le Protecteur et le Guérisseur. Votre vocation est d'apporter l'harmonie, l'amour inconditionnel et la bienveillance au cœur de votre foyer et de votre communauté.",
        qualities: ["Bienveillance naturelle", "Sens des responsabilités", "Générosité d'âme", "Esthétique raffinée"],
        challenges: ["Perfectionnisme excessif", "Tendance à tout porter", "Déficulté à dire non"],
        love: "L'amour est le centre de votre univers. Vous êtes prêt à déployer des trésors de tendresse pour protéger et embellir la vie de vos proches.",
        work: "Brille dans la santé, le bien-être, la décoration, l'éducation, le travail social ou l'artisanat d'art. Vous créez la beauté autour de vous.",
        advice: "Prenez soin de vous-même avec le même amour et la même exigence que vous donnez si généreusement aux autres."
    },
    7: {
        number: 7,
        description: "Le Chercheur de Vérité et le Sage. Votre voie réside dans l'analyse profonde, la quête de connaissances spirituelles et la maîtrise de soi.",
        qualities: ["Esprit d'analyse perçant", "Haute spiritualité", "Sagesse naturelle", "Lucidité philosophique"],
        challenges: ["Isolement excessif", "Sarcasme défensif", "Méfiance intempestive"],
        love: "Une recherche d'union intellectuelle et spirituelle très sélective. Vous préférez la solitude à un compromis de façade sans profondeur.",
        work: "Excellence dans la recherche scientifique, la philosophie, la numérologie, la psychologie ou les technologies de pointe.",
        advice: "Faites confiance aux révélations de votre intuition tout autant qu'à la logique de votre intellect."
    },
    8: {
        number: 8,
        description: "Le Stratège et le Maître de l'Abondance. Votre destinée est d'incarner le pouvoir personnel, la réussite matérielle et la justice équitable.",
        qualities: ["Incapacité à renoncer", "Vision stratégique", "Ambition noble", "Force de réalisation"],
        challenges: ["Rapport de force inutile", "Obsession du contrôle", "Lassitude face à l'échec"],
        love: "Passionné, magnétique et exigeant. Vous cherchez une relation forte où l'ambition partagée se conjugue avec un respect indéfectible.",
        work: "Predestiné aux affaires, à la haute finance, au leadership exécutif, à la politique ou à l'immobilier d'envergure.",
        advice: "Mettez votre puissance matérielle et financière au service d'une cause noble et inspirante."
    },
    9: {
        number: 9,
        description: "L'Humaniste et l'Inspirateur Universel. Votre mission est le don de soi, l'élévation des consciences et l'ouverture sur la fraternité mondiale.",
        qualities: ["Inspiration universelle", "Compassion sans limite", "Tolérance absolue", "Idéalisme élevé"],
        challenges: ["Rêverie déconnectée", "Deceptions fréquentes", "Peur de la solitude"],
        love: "Un amour romantique, idéaliste et sacrificiel. Vous aimez d'un cœur pur qui embrasse les qualités comme les imperfections de l'autre.",
        work: "Particulièrement à l'aise dans les causes humanitaires, l'enseignement, l'art international, les médecines alternatives ou le voyage.",
        advice: "Offrez vos talents au monde sans attendre de reconnaissance immédiate, la vie vous le rendra au centuple."
    },
    11: {
        number: 11,
        description: "Le Maître Intuitif et le Canal Céleste (Nombre Maître). Vous possédez un potentiel spirituel immense, une vision prophétique et une grande force d'éveil.",
        qualities: ["Intuition quasi-télépathique", "Rayonnement spirituel", "Inspiration fulgurante", "Force d'éveil"],
        challenges: ["Tension nerveuse élevée", "Hyper-émotivité", "Tendance aux vertiges d'égo"],
        love: "Un amour fusionnel à haute fréquence vibratoire. Vous attirez des partenaires qui ressentent le besoin d'une connexion d'âme hors du commun.",
        work: "Guide spirituel, thérapeute holistique, artiste visionnaire, inventeur de génie ou conférencier inspirant.",
        advice: "Ancrez-vous régulièrement dans la nature pour canaliser l'intensité de votre voltage spirituel."
    },
    22: {
        number: 22,
        description: "Le Grand Bâtisseur Universel (Nombre Maître). Vous combinez l'intuition géniale du 11 avec le réalisme pragmatique du 4 pour réaliser des œuvres colossales.",
        qualities: ["Capacité de concrétisation géante", "Vision d'ensemble hors norme", "Puissance de travail", "Génie pratique"],
        challenges: ["Pression interne écrasante", "Peur du vertige de la réussite", "Impatience cosmique"],
        love: "Vous avez besoin d'un partenaire solide capable de soutenir votre immense mission sans se sentir éclipsé par la taille de vos projets.",
        work: "Architecte de grands projets internationaux, fondateur d'organisations d'envergure, bâtisseur de systèmes ou leader mondial.",
        advice: "Mettez votre génie au service du bien commun pour accomplir les grands desseins de votre existence."
    },
    33: {
        number: 33,
        description: "Le Maître Guide et l'Amour Inconditionnel (Nombre Maître). Le chiffre de la compassion suprême, de l'élévation des êtres et de la guérison universelle.",
        qualities: ["Bénédiction spirituelle", "Guérison de l'âme", "Altruisme absolu", "Rayonnement d'Amour"],
        challenges: ["Poids du monde sur les épaules", "Épuisement émotionnel", "Sacrifice excessif"],
        love: "Un amour christique, protecteur et universel. Votre présence rassure et guérit instantanément les blessures du cœur.",
        work: "Médiateur mondial, maître spirituel, grand humaniste, médecin des âmes ou artiste d'envergure planétaire.",
        advice: "Aimez sans mesure mais veillez à protéger votre temple physique et émotionnel des énergies pesantes."
    }
};

export function getPreloadedNumerologyReading(number: number): PreloadedNumerologyReading {
    if (NUMEROLOGY_PRELOADED_READINGS[number]) {
        return NUMEROLOGY_PRELOADED_READINGS[number];
    }
    
    // Si réduction nécessaire pour tout nombre hors clé
    let reduced = number;
    while (reduced > 9 && reduced !== 11 && reduced !== 22 && reduced !== 33) {
        let sum = 0;
        const str = reduced.toString();
        for (let i = 0; i < str.length; i++) sum += parseInt(str[i], 10);
        reduced = sum;
    }

    return NUMEROLOGY_PRELOADED_READINGS[reduced] || NUMEROLOGY_PRELOADED_READINGS[1];
}
